<div [@routerTransition]>
<!--    <div class="kt-subheader kt-grid__item">-->
<!--        <div class="kt-subheader__main">-->
<!--            <h3 class="kt-subheader__title">-->
<!--                <span>{{ "Axilla.Webshop.FieldAgent.OrderConfirmation" | localize }}</span>-->
<!--            </h3>-->
<!--        </div>-->
<!--    </div>-->

    <div class="kt-content distribution">
        <div class="kt-portlet">
            <div class="kt-portlet__body">
                <div class="customers-details-section" *ngIf="selectedCustomer">
                    <div class="details-content">
                        <h3 class="mb-4">{{ selectedCustomer.company }} - {{selectedCustomer.debitorNumber}}</h3>
                        <h4 class="mb-5">{{ selectedCustomer | fullName }}</h4>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="customer-address-container">
                                    <h5 class="mb-3 h-flex">
                                        <strong> {{"DeliveryAddress" | localize}}</strong>
                                        <i class="fa fa-pencil-alt" (click)="editCustomer(selectedCustomer, EditCustomerMode.Delivery)"></i>
                                    </h5>

                                    <p [ngClass]="{'mb-0': selectedCustomerVba?.deliveryAddress}">
                                        <ng-container *ngIf="selectedCustomerVba?.deliveryAddress">
                                            {{selectedCustomerVba?.deliveryAddress.trim() }}
                                        </ng-container>
                                        <ng-container *ngIf="selectedCustomerVba?.deliveryAddressHouseNumber">
                                            &nbsp; {{selectedCustomerVba?.deliveryAddressHouseNumber}}
                                        </ng-container>
                                        <p-skeleton class="no-animation" *ngIf="!selectedCustomer?.deliveryAddress"/>
                                    </p>

                                    <p [ngClass]="{'mb-0': selectedCustomerVba?.deliveryAddressCity}">
                                        <ng-container *ngIf="selectedCustomerVba?.deliveryAddressPostcode">
                                            {{selectedCustomerVba?.deliveryAddressPostcode.trim() }}
                                        </ng-container>
                                        <ng-container *ngIf="selectedCustomerVba?.deliveryAddressCity">
                                            &nbsp; {{selectedCustomerVba?.deliveryAddressCity}}
                                        </ng-container>
                                        <ng-container *ngIf="selectedCustomerVba?.deliveryAddressCountry">
                                            &nbsp; {{selectedCustomerVba?.deliveryAddressCountry}}
                                        </ng-container>
                                        <p-skeleton class="no-animation" *ngIf="!selectedCustomerVba?.deliveryAddressCity"/>
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="customer-address-container">
                                    <h5 class="mb-3 h-flex">
                                        <strong> {{"InvoiceAddress" | localize}}</strong>
                                        <i class="fa fa-pencil-alt" (click)="editCustomer(selectedCustomer, EditCustomerMode.Invoice)"></i>
                                    </h5>

                                    <p [ngClass]="{'mb-0': selectedCustomerVba?.invoiceAddress}">
                                        <ng-container *ngIf="selectedCustomerVba?.invoiceAddress">
                                            {{selectedCustomerVba?.invoiceAddress}}
                                        </ng-container>
                                        <ng-container *ngIf="selectedCustomerVba?.invoiceAddressHouseNumber">
                                            &nbsp; {{selectedCustomerVba?.invoiceAddressHouseNumber}}
                                        </ng-container>
                                        <p-skeleton class="no-animation" *ngIf="!selectedCustomerVba?.invoiceAddress"/>
                                    </p>

                                    <p [ngClass]="{'mb-0': selectedCustomerVba?.invoiceAddressCity}">
                                        <ng-container *ngIf="selectedCustomerVba?.invoiceAddressPostcode">
                                            {{selectedCustomerVba?.invoiceAddressPostcode.trim() }}
                                        </ng-container>
                                        <ng-container *ngIf="selectedCustomerVba?.invoiceAddressCity">
                                            &nbsp; {{selectedCustomerVba?.invoiceAddressCity}}
                                        </ng-container>
                                        <ng-container *ngIf="selectedCustomerVba?.invoiceAddressCountry">
                                            &nbsp; {{selectedCustomerVba?.invoiceAddressCountry}}
                                        </ng-container>
                                        <p-skeleton class="no-animation" *ngIf="!selectedCustomerVba?.invoiceAddressCity"/>
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="customer-address-container">
                                    <h5 class="mb-3 h-flex">
                                        <strong> {{"Axilla.Webshop.FieldAgent.OrderConfirmation.NotificationEmail" | localize}} *</strong>
                                        <i class="fa fa-pencil-alt" (click)="showChangeNotificationEmailModal()"></i>
                                    </h5>

                                    <p class="mb-0">
                                        <ng-container *ngIf="notificationEmail">
                                            {{notificationEmail}}
                                        </ng-container>
                                        <p-skeleton class="no-animation" *ngIf="!notificationEmail"/>
                                    </p>

                                    <div class="validation error">
                                        <span *ngIf="!notificationEmail">
                                        {{"Required" | localize}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mt-3 mb-3 supplier-container">
                            <div>{{"Axilla.Webshop.FieldAgent.OrderConfirmation.Supplier" | localize}}:</div>
                            <div>
                                <p [ngClass]="{'mb-0': supplier}">
                                    <ng-container *ngIf="supplier">
                                        {{supplier}}
                                    </ng-container>
                                    <p-skeleton class="no-animation" *ngIf="!supplier"/>
                                </p>
                            </div>
                        </div>

                        <div class="mb-5 total-container">
                            {{"Axilla.Webshop.FieldAgent.OrderConfirmation.OrderValue" | localize}}: {{ total | currency:getCurrency():'symbol-narrow':'.2-2' }}
                        </div>
                    </div>

                    <div class="signature-container">
                        <div class="p-d-flex p-jc-between p-align-center p-mb-2">
                            <div>{{"Sign" | localize}}</div>
                            <app-clock></app-clock>
                            <div>{{ selectedCustomerVba?.addressCity }}</div>
                        </div>

                        <app-signature-pad #signaturePadComponent [height]="300"
                               (signatureSaved)="updateSignature($event)"
                               (onClear)="clearSignature($event)"
                               (onValidateSignature)="validateSignature($event)"></app-signature-pad>
                    </div>

                    <div class="p-d-flex p-jc-around p-align-center p-mt-4">
                        <div class="p-d-flex p-jc-around p-align-center p-mt-4">
                            <button class="btn btn-primary"
                                    [disabled]="!isValidSignature || !notificationEmail"
                                    (click)="onSubmitAsDraft()">{{"SaveAsDraft" | localize}}</button>

                            <button class="btn btn-primary"
                                    [disabled]="!isValidSignature || !notificationEmail"
                                    (click)="onSubmit()">{{"Submit" | localize}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<editCustomerModal #editCustomerModal [options]="editCustomerOptions" (onSubmit)="onEditCustomer($event)"></editCustomerModal>
<changeNotificationEmailModal #changeNotificationEmailModal (onSubmit)="onEditNotificationEmail($event)"></changeNotificationEmailModal>
